export const GET_BOM_SCRAP_LOG = 'GET_BOM_SCRAP_LOG';
export const GET_BOM_SCRAP_LOG_SUCCESS = 'GET_BOM_SCRAP_LOG_SUCCESS';
export const GET_BOM_SCRAP_LOG_FAILED = 'GET_BOM_SCRAP_LOG_FAILED';

export const ADD_BOM_SCRAP_LOG = 'ADD_BOM_SCRAP_LOG';
export const ADD_BOM_SCRAP_LOG_SUCCESS = 'ADD_BOM_SCRAP_LOG_SUCCESS';
export const ADD_BOM_SCRAP_LOG_FAILED = 'ADD_BOM_SCRAP_LOG_FAILED';

export const UPDATE_BOM_SCRAP_LOG = 'UPDATE_BOM_SCRAP_LOG';
export const UPDATE_BOM_SCRAP_LOG_SUCCESS = 'UPDATE_BOM_SCRAP_LOG_SUCCESS';
export const UPDATE_BOM_SCRAP_LOG_FAILED = 'UPDATE_BOM_SCRAP_LOG_FAILED';

export const DELETE_BOM_SCRAP_LOG = 'DELETE_BOM_SCRAP_LOG';
export const DELETE_BOM_SCRAP_LOG_SUCCESS = 'DELETE_BOM_SCRAP_LOG_SUCCESS';
export const DELETE_BOM_SCRAP_LOG_FAILED = 'DELETE_BOM_SCRAP_LOG_FAILED'; 